import * as comparatorUtilities from  "../../utility/comparator";

export default ngModule => {


  /**
   * Helper to create object with specified keys each containing approximately the same number of values from col
   * @param col
   * @param keys
   * @returns {Object}
   */
  function splitToKeys(col, keys) {
    const parts = _.chunk(col, Math.ceil(col.length / keys.length));
    return _.zipObject(keys, parts);
  }

  function getProductFeatures(services, productServices, benefits = false) {
    let productFeatures = {};
    for (let feature of services) {
      productFeatures[feature.id] = _(productServices)
        .filter(productService => productService.service === feature.id)
        .first();
    }
    return productFeatures;
  }

  ngModule.controller('ComparatorStep2Ctrl', function (
    AonApi,
    AonApplicationService,
    AonConfig,
    AonProducts,
    matchmedia,
    $sce,
    $scope,
    services,
    $state,
    $stateParams) {

    this.corporate = AonConfig.corporate;

    $scope.$parent.ctrl.scrollToId('step-progress-header', 100);

    this.isRefinePaneOpen = true;
    $scope.$parent.ctrl.refine_pane_open = this.isRefinePaneOpen;
    this.isLoadingResults = false;
    this.isFetchingPage = false;
    this.debugOverlay = AonApplicationService.isDebug();
    this.debugToggled = false;

    this.displayState = {
      resultOffset: 0,
      totalResults: 0,
      priceLimit: 0,
    };

    this.onScrollRight = () => {
      this.displayState.resultOffset = Math.min(this.displayState.resultOffset + 1, this.displayState.totalResults - this.displayState.priceLimit);
      this.displayState.resultOffset = Math.max(this.displayState.resultOffset, 0);
      this.isFetchingPage = true;
      this.refine(true);
    };

    this.onScrollLeft = () => {
      this.displayState.resultOffset = Math.max(this.displayState.resultOffset - 1, 0);
      this.isFetchingPage = true;
      this.refine(true);
    };

    this.canScrollLeft = () => this.displayState.resultOffset > 0;
    this.canScrollRight = () => this.displayState.priceLimit*(this.displayState.resultOffset + 1) < this.displayState.totalResults;

    this.viewingPackages = () => {
      if (this.packages.length) {
        const minProd = this.displayState.resultOffset*this.displayState.priceLimit + 1;
        const maxProd = Math.min(minProd + this.displayState.priceLimit - 1, this.displayState.totalResults);
        const totalProd = this.displayState.totalResults;
        if (totalProd == 1) {
          this.displayState.viewingText = `Showing 1 policy`;
        } else {
          this.displayState.viewingText = `Showing ${minProd} to ${maxProd} of ${totalProd} policies`;
        }
      }
      //return this.packages.slice(this.displayState.resultOffset, this.displayState.resultOffset + 3);
      return this.packages;
    };

    this.servicesInColumns = {
        hospital:  splitToKeys(services.hospital.sort( (a,b) => b.sort_order - a.sort_order), ['left', 'right']),
        ancillary:  splitToKeys(services.ancillary.sort( (a,b) => b.sort_order - a.sort_order), ['left', 'right'])
    };

    this.services = services;

    this.openRefinePane = () => {
      $scope.$parent.ctrl.scrollToId('step-progress-header');
      this.isRefinePaneOpen = true;
      $scope.$parent.ctrl.refine_pane_open = true;
    };

    this.closeRefinePane = () => {
      this.isRefinePaneOpen = false;
      $scope.$parent.ctrl.refine_pane_open = false;
    };

    this.refine = (leavePaneOpen = false) => {
      const excess_field = 'excess';

      this.results_pane_continue_text = this.corporate.refine_results_execute_text;
      const [ancillary, hospital] = [_.filter(services.ancillary, 'selected'), _.filter(services.hospital, 'selected')];

      this.isLoadingResults = true;

      const success = response => {
        this.displayState.totalResults = response.data.total;
        this.displayState.priceLimit = response.data.limit;

        let rebatePercentage = comparatorUtilities.calcRebate(this.applicant, AonApplicationService);
        let healthCoverLoading = comparatorUtilities.calcLHC(this.applicant, AonApplicationService);
        this.applicant.policy.healthCoverLoading = healthCoverLoading;
        this.applicant.policy.rebatePercentage = response.data.applicant.rebate_percent;

        const packages = response.data.packages,
              // Get max number of excess options for a package
              maxExcessCount = _(packages).pluck('prices').map('length').max();

        this.responsive = packages.length < 4;

        this.packages = _.map(response.data.packages, (pricePackage) => {

          pricePackage.prices = _.map(pricePackage.prices, p => {
            p[excess_field] = p[excess_field].split(".")[0];
            return p;
          });
          pricePackage.prices = pricePackage.prices.sort( (a,b) => b[excess_field] - a[excess_field] );

          comparatorUtilities.priceCalculations(pricePackage, rebatePercentage, healthCoverLoading);

          pricePackage.selectedPrice = pricePackage.prices[0];
          pricePackage.features = {
            hospital: getProductFeatures(this.services.hospital, pricePackage.hospital_product.product_hospital_services),
            ancillary: getProductFeatures(this.services.ancillary, pricePackage.ancillary_product.product_ancillary_services)
          };
          pricePackage.showUnselectedServices = {
            hospital: false,
            ancillary: false
          };

          // Calculate how many prices this package is short by. This is purely so we can add empty dom elements
          // so that heights match up across columns in the HTML. Not very elegant, but easiest solution while
          // maintaining responsive flow of columns.
          const shortBy = maxExcessCount - pricePackage.prices.length;
          if (shortBy > 0) {
            pricePackage.fillerPrices = _.range(0, shortBy)
          }
          return pricePackage
        });

        if (!leavePaneOpen) {
          this.displayState.resultOffset = 0;
          this.closeRefinePane();
          $scope.$parent.ctrl.scrollToId('step-progress-header', 100);
        }
      }, error = err => {
        console.log(err);
      }, fin = () => {
        this.isLoadingResults = false;
        this.isFetchingPage = false;
      }

      let filters = { offset: this.displayState.resultOffset }
      AonProducts.searchPackages(this.applicant, {hospital, ancillary}, filters).then(success, error)['finally'](fin);
    };

    // Build a list of applicable fund-level offers
    this.packageFundOffers = (fund) => {
      return this.corporate.fund_offers
          .filter(o => (o.cover == this.applicant.policy.cover_type) && (fund.id == o.fund_id));
    };

    this.toggleUnselectedServiceSummary = (pkg, type) => {
      if (matchmedia.isPhone()) {
        pkg.showUnselectedServices[type] = !pkg.showUnselectedServices[type];
      } else {
        const status = !pkg.showUnselectedServices[type];
        for (let p of this.packages) {
          p.showUnselectedServices[type] = status;
        }
      }
    };

    this.apply = (price, pkg) => {
      pkg.isTransitioningToApply = true;
      AonApplicationService.saveApplication(this.applicant);
      AonApplicationService.setProduct(pkg);
      AonApplicationService.setPrice(price);
      let code = price.fund.code.split('.')[0];
      $state.transitionTo(`comparator.step3.${code}`);
    };

    AonApplicationService.getApplication().then(applicant => {
      this.applicant = applicant;

      // Emailed quote returning
      if ($stateParams.quote) {
        var quote = JSON.parse($stateParams.quote);

        // Set selected services from the email info
        _.forEach(this.services.hospital, function(obj) {
          obj.selected = _.includes(_.map(quote.hospital, x => x.id), obj.id);
        });
        _.forEach(this.services.ancillary, function(obj) {
          obj.selected = _.includes(_.map(quote.ancillary, x => x.id), obj.id);
        });

        this.applicant.policy.cover_type = quote.cover;
        this.applicant.policy.membership_type = quote.membership;
        this.applicant.policy.federal_rebate = quote.federal_rebate;
        this.applicant.policy.rebate_tier = quote.rebate_tier;
        this.applicant.primary_address.state = quote.state;

        this.applicant.personal = {
          dob: quote.dob,
          previous_fund: {
            has_previous_fund: quote.has_previous_fund,
          }
        }

        this.applicant.displayValues = this.applicant.getSummaryDetails();

        // Notify the backend for reporting
        AonApi.post('quotes/email/returning', { tracking: quote.tracking });
      }

      this.requiresAncillaryProducts = this.applicant.requiresAncillaryProducts();
      this.requiresHospitalProducts = this.applicant.requiresHospitalProducts();
      this.results_pane_continue_text = this.corporate.refine_results_continue_text;
    });

    this.emailQuoteSendResult = {
      attempted: false,
      error: false
    };

    this.emailQuote = function(form) {
      if (!form.$valid) {
        return;
      }
      // Get the selected ancillary and hospital ids for inclusion in the email link
      const [ancillary, hospital] = [
        _.map(_.filter(services.ancillary, 'selected'), obj => ({id:obj.id, name:obj.name})),
        _.map(_.filter(services.hospital, 'selected'), obj => ({id:obj.id, name:obj.name}))
      ];

      const success = response => {
        this.emailQuoteSendResult.attempted = true;
        this.emailQuoteSendResult.error = !response.data.sent;
      }
      const failure = response => {
        this.emailQuoteSendResult.attempted = true;
        this.emailQuoteSendResult.error = true;
      }

      AonApi.post('quotes/email',
          {
            applicant: {
              email: this.applicant.contact.email_address,
              cover: this.applicant.policy.cover_type,
              dob: this.applicant.personal.dob,
              federal_rebate: this.applicant.policy.federal_rebate,
              rebate_tier: this.applicant.policy.rebate_tier,
              has_previous_fund: this.applicant.personal.previous_fund.has_previous_fund,
              membership: this.applicant.policy.membership_type,
              state: this.applicant.primary_address.state,
              hospital: hospital,
              ancillary: ancillary,
            },
            packages: this.packages
          })
          .then(success, failure);
    };

    // Get any general offers from the fund, to display in a modal
    this.fundPopupOffers = () => {
      return this.corporate.fund_offers.filter(o => o.cover == -1).map(o => $sce.trustAsHtml(o.offer));
    };

    // TODO: remember when shown at least once? Could get annoying...
    if (this.fundPopupOffers().length) {
      $("div#fund-offers-modal").modal("show");
    }

    this.isProductClosed = price => price.product_status === AonConfig.jsConstants.ProductPriceStatus.CLOSED;

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step2-ctrl.js